export AuthorLink from './AuthorLink/AuthorLink';
export CompilationTypeSelector from './CompilationTypeSelector/CompilationTypeSelector';
export CreatePatchTile from './CreatePatchTile/CreatePatchTile';
export GenPatchFileSVG from './GenPatchFileSVG/GenPatchFileSVG';
export Icon from './Icon/Icon';
export IconButton from './IconButton/IconButton';
export NavLink from './NavLink/NavLink';
export PatchCounter from './PatchCounter/PatchCounter';
export PatchDetailsTile from './PatchDetailsTile/PatchDetailsTile';
export PatchSoundcloud from './PatchSoundcloud/PatchSoundcloud';
export PatchStats from './PatchStats/PatchStats';
export PatchTileSmall from './PatchTileSmall/PatchTileSmall';
export StarCounter from './StarCounter/StarCounter';
export SubFilterButton from './SubFilterButton/SubFilterButton';
export Tag from './Tag/Tag';



// WEBPACK FOOTER //
// ./src/components/index.js